export default __webpack_public_path__ + "static/media/placeholder_portfolio03-fr-mobile.660fc524.png";